import React, {useContext, useEffect, useState} from "react"
import Container from "../components/Container";
import Api from "../utilis/api/service"
import workflow from "../utilis/interfaces/Workflow";
import urls from "../utilis/api/Urls";
import {Divider, Result, Timeline} from 'antd';
import {AxiosResponse} from "axios";
import AppContext from "../utilis/contexts/AppContext";
import Texts from "../utilis/defaults/Text";
import {useLocation} from "react-router-dom";
import LocalStorage from "../utilis/tools/LocalStorage";
import {FrownOutlined} from "@ant-design/icons";
const WorkFlow = () => {
    const [workflows, setWorkflows] = useState<Array<workflow>>([]);
    const [state, setState] = useState<any>({});
    const url = new URL(window.location.href);
    const thisToken = url.searchParams.get("token") || "";
    const appContext=useContext(AppContext);
    const {state:State}:any = useLocation();
    const { TraceNumber, BillId,Cellphone } = State;

    useEffect(() => {
        appContext.handleLoading(true)
        if(TraceNumber){
            Api.post(urls.GetDataWorkFlow,{
                Cellphone:Cellphone,
                BillId:BillId,
                TraceNumber:TraceNumber
            },{
                headers: {
                    "Authorization": LocalStorage.getToken().token_type + " " + LocalStorage.getToken().access_token
                }
            }).then((response:AxiosResponse)=>{

                const {data}=response;
                const {Status,Data}=data;

                if(Status===0){
                    const {flows, bill_id, national_code, trace_number, request_code, order_type} = Data;

                    setState({
                        traceNumber: trace_number,
                        requestCode: request_code,
                        billId: bill_id,
                        nationalCode: national_code,
                        orderType: order_type,

                    })
                    setWorkflows(flows)
                }
                if(Status===-1){
                    setWorkflows([])
                }
            }).catch(e=>{

            }).finally(()=>{
                appContext.handleLoading(false)
            })
        }else if(thisToken.length>0) {
            Api.get(urls.RequestWorkFlow+thisToken).then((response:AxiosResponse)=>{

                const {data}=response;
                const {Status,Data}=data;
                if(Status===0){
                    const {flows, bill_id, national_code, trace_number, request_code, order_type} = Data;
                    setState({
                        traceNumber: trace_number,
                        requestCode: request_code,
                        billId: bill_id,
                        nationalCode: national_code,
                        orderType: order_type,

                    })
                    setWorkflows(flows)
                }

            }).catch(e=>{

            }).finally(()=>{
                appContext.handleLoading(false)
            })
        }




    }, [])
    return <div>
        {((!TraceNumber || thisToken.length!==0) &&    <div className="workflowHero">
            <Container className="flex rounded-lg overflow-hidden justify-center items-center flex-col pt-[40px] h-full ">
                <h3 className="text-2xl font-bold text-white pb-[5px]   border-b  border-white mb-3 text-center   relative z-30">
                    {Texts.appName}
                </h3>
                <h6 className="h6 text-white text-lg pb-5 border-bottom border-white mb-3 text-center  position-relative z-30">
                    پیگیری درخواست {state.orderType}
                </h6>
                <div className={"workflowData"}>
                    <div className="m-3"><span>کد ملی : </span> {state.nationalCode}</div>

                    <div className="m-3"><span> کد یکتا درخواست : </span> {state.requestCode}</div>
                    <div className="m-3"><span> شناسه قبض : </span> {state.billId}</div>
                    <div className="m-3"><span> شماره پیگیری : </span> {state.traceNumber}</div>
                </div>
            </Container>
        </div>)}
        {TraceNumber && <Divider><h3 className="font-bold ">جریان های کاری من</h3></Divider>}
        <Container className={TraceNumber ? 'col-12':'col-12 lg:col-lg-8  mt-10 '}>
            <Timeline>
                {workflows.map((workflow, index) => {
                    return  <Timeline.Item key={'work-flow-'+index}><div className="w-full shadow border-l-[10px] border-primary p-5 rounded-lg">
                        <div className="justify-start items-center flex flex-wrap ">
                            <span className="ml-4"><strong>تاریخ پیامک : </strong>{workflow.sms_date}</span>
                            <span><strong>تاریخ ارجاع : </strong>{workflow.start_date}</span>
                        </div>
                       <Divider/>
                        <p className="text-sm mt-4 ">{workflow.description}
                        </p>
                    </div></Timeline.Item>
                })}
                {workflows.length===0  && <Result
                    icon={<FrownOutlined />}
                    subTitle="هیچ جریانی  یافت نشد."

                />}
            </Timeline>

        </Container>
    </div>
}
export default WorkFlow;